import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// A Workflow Maintenance card while its Preview or Apply runs in the background
// (#17961). Shows how long it has been running and polls the run's status; when
// the run is no longer queued or running, the page reloads so the card shows its
// result and history. A failed poll just tries again on the next tick.
export default class extends Controller {
  static POLL_MS = 3000
  static TICK_MS = 1000
  static targets = ["elapsed"]
  static values = { statusUrl: String, startedAt: String }

  connect() {
    this.renderElapsed()
    this.ticker = setInterval(() => this.renderElapsed(), this.constructor.TICK_MS)
    this.schedule()
  }

  disconnect() {
    clearInterval(this.ticker)
    clearTimeout(this.timer)
  }

  async poll() {
    try {
      const response = await get(this.statusUrlValue, { responseKind: "json" })
      if (response.ok) {
        const status = await response.json
        if (!status.active) return this.finished()
      }
    } catch (_error) {
      // A dropped request is retried on the next tick.
    }
    this.schedule()
  }

  finished() {
    clearInterval(this.ticker)
    window.location.reload()
  }

  // private

  schedule() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.poll(), this.constructor.POLL_MS)
  }

  renderElapsed() {
    if (!this.hasElapsedTarget || !this.startedAtValue) return

    const seconds = Math.max(0, Math.floor((Date.now() - new Date(this.startedAtValue).getTime()) / 1000))
    const minutes = Math.floor(seconds / 60)
    const rest = String(seconds % 60).padStart(2, "0")
    this.elapsedTarget.textContent = ` · ${minutes}:${rest} elapsed`
  }
}
